import { API_BASE } from '@/services/index';

export const getApiImageURL = (imageURL: string) => `${API_BASE}storage/file?filePath=${imageURL}`;
